export const colors = {
  dark: {
    bg: '#000',
    cardBg: '#090909',
    text: '#FFF',
    bg08: 'rgba(0,0,0,0.8)',
    bg07: 'rgba(75,75,75,0.9)',
    buttonBorder: '#4B4B4B',
    pin: 'rgba(250,250,250,0.8)',
    gray: '#333',
    gray2: '#4B4B4B',
    gray3: '#444',
    gray4: '#888',
    gameButtonBg: '#292929',
    gamePreamble: '#292929',
    checkbox: '#4B4B4B',
    switcherBG: '#000',
    toggleTrackOn: '#654522',
    toggleTrackOff: '#636466',
    toggleThumbOn: '#f9ad64',
    toggleThumbOff: '#b9b9b9'
  },
  light: {
    bg: '#FFF',
    cardBg: '#FAFAFA',
    text: '#000',
    bg08: 'rgba(255,255,255,0.8)',
    bg07: 'rgba(0,0,0,0.7)',
    buttonBorder: 'rgba(230, 230, 230, 0.85)',
    pin: 'rgba(50,50,50,0.8)',
    gray: '#EEE',
    gray2: '#9C9C9C',
    gray3: '#CCC',
    gray4: '#888',
    gameButtonBg: '#FFF',
    gamePreamble: '#F2F2F2',
    checkbox: '#E3E3E3',
    switcherBG: '#E3E3E3',
    toggleTrackOn: '#f4dac7',
    toggleTrackOff: '#BDBDBD',
    toggleThumbOn: '#EB871C',
    toggleThumbOff: '#ECECEC'
  }
};
